import { useState } from 'react'

import { SUB_MENU_INITIAL_STATE } from '../constants/menu'
import { SubMenuActionsContext, SubMenuContext } from '../context'

function SubMenuProvider({ children }) {
  const [subMenu, setSubMenu] = useState(SUB_MENU_INITIAL_STATE)

  function cleanSubMenu() {
    setSubMenu(SUB_MENU_INITIAL_STATE)
  }

  function setSecondaryMenu(items) {
    setSubMenu(prev => ({ ...prev, items }))
  }

  function setSubMenuAccounts(accounts) {
    setSubMenu(prev => ({ ...prev, accounts }))
  }

  function setSubMenuIdwellToIdwellCompanies(idwellToIdwellCompanies) {
    setSubMenu(prev => ({ ...prev, idwellToIdwellCompanies }))
  }

  const actions = {
    cleanSubMenu,
    setSecondaryMenu,
    setSubMenuAccounts,
    setSubMenuIdwellToIdwellCompanies,
  }

  return (
    <SubMenuContext value={subMenu}>
      <SubMenuActionsContext value={actions}>{children}</SubMenuActionsContext>
    </SubMenuContext>
  )
}

export default SubMenuProvider
